import { ApiResolver } from '@schibsted-nmp/advertising-shared';
import { $config } from '@client/core/atoms/config.js';

import type { Window } from './Window.js';

import type { Api } from './index.js';

export const { globalPropertyName, unsafePropertyName } =
  ApiResolver.getGlobalPropertyNames('googletag');

export class Resolver extends ApiResolver<
  Api.Uninitialized,
  Api.Initialized,
  Api.Loaded,
  Window
> {
  /**
   * Provides synchronous access to a fully loaded global reference.
   *
   * *Warning: throws if it's not fully loaded!*
   * @see {@linkcode ApiResolver.loadedGlobalRef}.
   */
  get [unsafePropertyName]() {
    return this.loadedGlobalRef;
  }

  protected readonly globalPropertyName = globalPropertyName;

  protected override initialize(
    window: Window.AsUninitialized
  ): asserts window is Window.AsInitialized {
    (window[this.globalPropertyName] ??= {}).cmd ??= [];
  }

  protected override isEnabled() {
    const config = $config.get();
    if (!config?.adServer.gam) return false;

    return true;
  }

  protected override isInitialized(
    window: typeof globalThis.window
  ): window is Window.AsInitialized {
    return window[this.globalPropertyName]?.cmd !== undefined;
  }

  protected override isLoaded(
    globalRef: Api.Initialized | Api.Loaded
  ): globalRef is Api.Loaded {
    return 'apiReady' in globalRef && globalRef.apiReady;
  }

  protected override enqueue(
    globalRef: Api.Initialized | Api.Loaded,
    executor: () => void
  ) {
    globalRef.cmd.push(executor);
  }
}
